import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  NONCASH_GIFT_AND_AWARDS = "Non-cash gifts & awards",
  EDUCATION = "Education",
  MEDICAL_INSURANCE = "Medical insurance",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal allowance",
  LIVING_ACCOMMODATION = "Living accommodation",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);
export const TaxableBenefitsTypeMessage = null;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
